import React, { useContext, useEffect, useState, VFC } from 'react';

import { AppShellContext } from '/utils/contexts';
import { useCwaAxios } from '/utils/cwaAxios';

type NavigationApiResponse = MintelNavOptions | null;

const Navigation: VFC = () => {
  const [apiResponse, setApiResponse] = useState(null as NavigationApiResponse);

  const { configureNavigation } = useContext(AppShellContext);
  const cwaAxios = useCwaAxios();

  useEffect(() => {
    setApiResponse(null);
    cwaAxios
      .get('/api/content/navigation')
      .then((resp) => setApiResponse(resp.data));
  }, [cwaAxios]);

  useEffect(() => {
    if (apiResponse) {
      configureNavigation(apiResponse);
    }
  }, [apiResponse, configureNavigation]);

  return <></>;
};

export default Navigation;
